import decoder from '../utils/decoder.js'

let API = {
	formatDateString: function(dateString, fmt) {
		if (!dateString || '--' == dateString) {
			return dateString;
		} else if ("99991231" == dateString) {
			return "长期";
		}
		var n = new Date();
		var year = n.getYear();
		var month = n.getMonth() + 1;
		var day = n.getDay();
		var hour = n.getHours();
		var minute = n.getMinutes();
		var second = n.getSeconds();
		if (dateString.length == 8 || dateString.length == 14) {
			year = parseInt(dateString.substring(0, 4), 10);
			month = parseInt(dateString.substring(4, 6), 10) - 1;
			day = parseInt(dateString.substring(6, 8), 10);
		}
		if (dateString.length == 6) {
			hour = parseInt(dateString.substring(0, 2), 10);
			minute = parseInt(dateString.substring(2, 4), 10);
			second = parseInt(dateString.substring(4, 6), 10);
		} else if (dateString.length == 14) {
			hour = parseInt(dateString.substring(8, 10), 10);
			minute = parseInt(dateString.substring(10, 12), 10);
			second = parseInt(dateString.substring(12, 14), 10);
		}
		var date = new Date(year, month, day, hour, minute, second);
		return this.formatDate(date, fmt);
	},
	/**
	 * 日期格式化
	 * @param {string}  date: 日期或日期字符串
	 * @param {string}  fmt: 日期格式字符串
	 */
	formatDate: function(date, fmt = 'yyyy-MM-dd') {
		if (!date) date = new Date();
		if (typeof date === 'string') date = new Date(date.replace(/(\d{4})[^\d]?(\d{2})[^\d]?(\d{2})/,
			'$1/$2/$3'));
		var o = {
			'M+': date.getMonth() + 1,
			'd+': date.getDate(),
			'h+': date.getHours(),
			'm+': date.getMinutes(),
			's+': date.getSeconds(),
			'q+': Math.floor((date.getMonth() + 3) / 3),
			'S': date.getMilliseconds()
		};
		var week = {
			'0': '\u65e5',
			'1': '\u4e00',
			'2': '\u4e8c',
			'3': '\u4e09',
			'4': '\u56db',
			'5': '\u4e94',
			'6': '\u516d'
		};
		if (/(y+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
		}
		if (/(E+)/.test(fmt)) {
			fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' :
				'\u5468') : '') + week[date.getDay() + '']);
		}
		for (const k in o) {
			if (new RegExp('(' + k + ')').test(fmt)) {
				fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[
						k])
					.length)));
			}
		}
		return fmt;
	},
	/** 净值格式化
	 * @param {string} nav 净值
	 * @param {integer} p 精度位数
	 */
	formatNav: function(nav, p = 4) {
		if (isNaN(parseFloat(nav))) {
			return "--"
		} else {
			return parseFloat(nav).toFixed(p);
		}
	},
	/**格式化金额
	 * @param {string} val 金额
	 */
	formatSum: function(val) {
		val = val.toString();
		let mSymbol = "";
		if (!!val && (val.substr(0, 1) == "-" || val.substr(0, 1) == "+")) {
			mSymbol = val.substr(0, 1);
			val = val.substr(1, val.length - 1);
		}
		let arrayVal = val.toString().replace(/,/g, '');
		arrayVal = arrayVal.split(".");
		if (arrayVal[1] == undefined) {
			arrayVal[1] = "00";
		}
		let num = (arrayVal[0]) ? arrayVal[0].toString() : '',
			cent = (typeof arrayVal[1] != "undefined") ? "." + arrayVal[1] : "",
			moneyNum = '',
			result = '';

		cent = cent.substr(0, 3);

		while (num.length > 3) {
			moneyNum = ',' + num.slice(-3) + moneyNum;
			num = num.slice(0, num.length - 3);
		}
		if (num) {
			result = num + moneyNum + cent;
		}
		return mSymbol + result;
	},
	/** 两个浮点数求和
	 * @param {Object} num1
	 * @param {Object} num2
	 */
	add: function(num1, num2) {
		var r1, r2, m;
		try {
			r1 = num1.toString().split('.')[1].length;
		} catch (e) {
			r1 = 0;
		}
		try {
			r2 = num2.toString().split(".")[1].length;
		} catch (e) {
			r2 = 0;
		}
		m = Math.pow(10, Math.max(r1, r2));
		return Math.round(num1 * m + num2 * m) / m;
	},
	/**
	 *  两个浮点数相减
	 * @param {Object} num1
	 * @param {Object} num2
	 */
	sub: function(num1, num2) {
		var r1, r2, m, n;
		try {
			r1 = num1.toString().split('.')[1].length;
		} catch (e) {
			r1 = 0;
		}
		try {
			r2 = num2.toString().split(".")[1].length;
		} catch (e) {
			r2 = 0;
		}
		m = Math.pow(10, Math.max(r1, r2));
		n = (r1 >= r2) ? r1 : r2;
		return (Math.round(num1 * m - num2 * m) / m).toFixed(n);
	},
	date1week: function() {
		const date = new Date()
		date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
		return this.formatDate(date);
	},
	date1month: function() {
		const date = new Date();
		date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
		return this.formatDate(date);
	},
	date1reason: function() {
		const date = new Date();
		date.setTime(date.getTime() - 3600 * 1000 * 24 * 182);
		return this.formatDate(date);
	},
	date1year: function() {
		const date = new Date();
		date.setTime(date.getTime() - 3600 * 1000 * 24 * 365);
		return this.formatDate(date);
	},
	//日期比较
	dateCompare: function(start, end) {
		if (!!!start || !!!end) {
			return true;
		}
		return new Date(end).getTime() >= new Date(start).getTime()
	},
	//是否接口调用成功
	isSuccess: function(susCode) {
		return susCode == 'SUS-BP00000';
	},
	//是否图片验证码错误
	isAuthCodeError: function(susCode) {
		return susCode == "SUS-BP00018" || susCode == "SUS-BP00017" || susCode == "SUS-BP00007";
	},
	maskIdNo :function (idNo){
		return idNo.replace(/^(.{6})(?:\d+)(.{4})$/, "$1****$2");
	},
	maskMobileNo :function (mobileNo){
		return mobileNo.replace(/^(.{2})(?:\w+)(.{1})$/, "$1****$2");
	},
	handleRequest: function(request) {
		request.headers = {
			"hssessionid": sessionStorage.getItem('hssessionid') || '',
			'contentType': 'application/json',
			'secretKey': decoder.encodeHandshake(decoder.allocSessionToken())
		};
		return decoder.applyOutbound(request);
	},
	handleResponse: function(response) {
		if (!!response.headers['hssessionid']) {
			sessionStorage.setItem('hssessionid', response.headers['hssessionid']);
		}
		return decoder.applyInbound(response);
	}
};
export default API;



// WEBPACK FOOTER //
// ./src/utils/api.js